import { useLocation } from "react-router-dom";

const SITE = process.env.REACT_APP_SITE_URL;
const NAME = "Viral Vision Media";

export const ORGANIZATION = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: NAME,
  url: SITE,
  logo: `${SITE}/logo.png`,
  email: "info@viralvisionmediaau.com",
  areaServed: "AU",
  founder: [{ "@type": "Person", name: "Angela" }, { "@type": "Person", name: "Baxter" }],
  description: "Strategy, content production, paid advertising, websites and custom business systems for food businesses and growing Australian brands.",
};

export const LOCAL_BUSINESS = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE}/#business`,
  name: NAME,
  url: SITE,
  image: `${SITE}/logo.png`,
  email: "info@viralvisionmediaau.com",
  priceRange: "$$",
  description: "Marketing agency for food and product businesses: content production, paid advertising, websites and custom business systems. Based in Sydney, serving clients across Australia.",
  address: { "@type": "PostalAddress", addressRegion: "NSW", addressLocality: "Sydney", addressCountry: "AU" },
  areaServed: { "@type": "Country", name: "Australia" },
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE}${it.to}` })),
});

export const serviceSchema = ({ name, description, path, areaServed = "Sydney, Australia" }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${SITE}${path}`,
  provider: { "@type": "Organization", name: NAME, url: SITE },
  areaServed,
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

// One place for title, description, canonical, Open Graph, Twitter and JSON-LD.
export const Seo = ({ title, description, image = "/logo.png", type = "website", schema = [], noindex = false }) => {
  const { pathname } = useLocation();
  const canonical = `${SITE}${pathname === "/" ? "" : pathname.replace(/\/$/, "")}`;
  const fullTitle = title.includes(NAME) ? title : `${title} | ${NAME}`;
  const img = image.startsWith("http") ? image : `${SITE}${image}`;
  const blocks = [ORGANIZATION, LOCAL_BUSINESS, ...schema];
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:site_name" content={NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_AU" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(b) }} />)}
    </>
  );
};

export default Seo;
